import React, { useContext } from 'react';
import styled from '@emotion/styled';
import {
  MonthlyFeedbackDataType,
  MonthlyFeedbackInitialValues,
  MonthlyFeedbackSchema,
} from '../../../../models/feedback/feedback.model';
import ModalContainer from '../../ModalContainer';
import { TextInputField } from '../../../Form/FormField';
import { FormComponent } from '../../../Form/FormComponent';
import ValidatingFormSubmitButton from '../../../Button/FormSubmitButton';
import CustomRating from '../../../Form/CustomRating';
import MonthlyFeedBackGrandChild from '../GrandChildren/MonthlyFeedbackGrandChild';
import { ModalContext } from '../../../../context/ModalContext';
import useSubmitMonthlyFeedback from '../../../../hooks/feedbacks/useSubmitMonthlyFeedback';

const MonthlyFeedbackModal = () => {
  const { displayModal } = useContext(ModalContext)!;

  const { submitMonthlyFeedback, loading } = useSubmitMonthlyFeedback();

  const handleSubmit = async (values: MonthlyFeedbackDataType) => {
    await submitMonthlyFeedback(values);
    displayModal(false);
  };

  const confirmClose = () => {
    sessionStorage.setItem('SMFP', 'false');
    sessionStorage.setItem('SIFP', 'false');
  };

  return (
    <ModalContainer
      padding="2rem"
      confirm
      granChild={<MonthlyFeedBackGrandChild />}
      onConfirmClose={confirmClose}
    >
      <Header>Help us make Locumspace better for everyone</Header>
      <FormComponent
        initialValues={MonthlyFeedbackInitialValues}
        schema={MonthlyFeedbackSchema}
        onSubmit={handleSubmit}
      >
        <CustomRating name="rating" />
        <TextInputField
          type="text"
          name="ratingReason"
          label={'Tell us why you picked the above score ?'}
        />
        <Div>
          <ValidatingFormSubmitButton
            className="fillParent max-318"
            loading={loading}
          >
            SUBMIT
          </ValidatingFormSubmitButton>
          <p>Page 1 of 1</p>
        </Div>
      </FormComponent>
    </ModalContainer>
  );
};

export default MonthlyFeedbackModal;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.7rem;
  justify-content: center;
  align-items: center;
`;

const Header = styled.h3`
  font-family: Kanit;
  font-weight: 500;
  font-style: Medium;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -2%;
  text-align: center;
  color: ${({ theme }) => theme.palette.blackBlackMain};

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;
